var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCkeck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 0.274606C13.4855 -0.0808865 12.9573 -0.0808865 12.6302 0.274606L7.90097 5.41558L9.08328 6.70082L13.8125 1.55073C14.1312 1.20436 14.1312 0.620984 13.8125 0.274606ZM17.3679 0.265491L9.08328 9.27131L6.16523 6.10834C5.83821 5.75284 5.30994 5.75284 4.98291 6.10834C4.65589 6.46383 4.65589 7.03809 4.98291 7.39358L8.48793 11.2037C8.81496 11.5592 9.34323 11.5592 9.67025 11.2037L18.5502 1.55985C18.8772 1.20436 18.8772 0.630099 18.5502 0.274606H18.5418C18.2232 -0.0900017 17.6949 -0.0900019 17.3679 0.265491ZM0.245268 7.40269L3.75029 11.2128C4.07731 11.5683 4.60558 11.5683 4.9326 11.2128L5.51957 10.5748L1.42758 6.10834C1.10056 5.75284 0.572291 5.75284 0.245268 6.10834C-0.0817558 6.46383 -0.0817558 7.0472 0.245268 7.40269Z",
    fill: "#6200EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCkeck);
export default __webpack_public_path__ + "static/media/double-ckeck.bcef8e6ca6ef5122bde58585f7b4c88d.svg";
export { ForwardRef as ReactComponent };